import { render, staticRenderFns } from "./registerModal.vue?vue&type=template&id=499551d5&scoped=true&"
import script from "./registerModal.vue?vue&type=script&lang=js&"
export * from "./registerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499551d5",
  null
  
)

export default component.exports